import './Header.scss';

const getFallbackWelcomeMessage = (theme) => {
  if (theme === 'disney-toy-story-5') {
    return 'WELCOME TO THE<br />TOY STORY 5 <span class="text-highlight">QUIZ</span>';
  }

  return 'WELCOME TO THE<br />TEAM LEWIS <span class="text-highlight">QUIZ</span>';
};

const WelcomeHeader = ({ theme, welcomeMessage }) => {
  const headerMarkup = welcomeMessage || getFallbackWelcomeMessage(theme);

  return (
    <header
      className="header header--welcome pt-3 pt-md-3 text-center"
      dangerouslySetInnerHTML={{ __html: headerMarkup }}
    />
  );
}

export default WelcomeHeader;
